<template>
  <div class="shopping_car">
    <b-container class="py-3 py-lg-5" v-if="data">
      <div class="row">
        <div class="col-xl-7">
          <div
            class="border row shopping_car-header mb-2 mb-lg-4 py-2 d-none d-md-flex"
          >
            <div class="col-auto shopping_car-checkbox variant-platform">
              <b-form-checkbox v-model="allSelected" @change="checkCar">
              </b-form-checkbox>
            </div>
            <div class="col shopping_car-product-name">
              商品
            </div>
            <div class="col-auto shopping_car-product-price text-center">
              單價
            </div>
            <div class="col-auto shopping_car-product-count text-center">
              數量
            </div>
            <div class="col-auto shopping_car-product-subtotal text-center">
              小計
            </div>
            <div class="col-auto shopping_car-product-delete text-center">
              刪除
            </div>
          </div>
          <div
            class="shopping_car-group mb-2 mb-lg-4"
            v-for="(product, key) in data"
            :key="key"
          >
            <div
              class="border row shopping_car-header py-2"
              :style="{
                borderTop: '3px solid ' + randomcolor() + '!important'
              }"
            >
              <div
                class="col-auto shopping_car-checkbox variant-platform"
                v-if="checkboxedList"
              >
                <b-form-checkbox
                  v-model="checkboxedList[key].allCompany"
                  @change="checkCompany(key)"
                >
                </b-form-checkbox>
              </div>
              <div class="col shopping_car-company_name">
                <b-icon
                  icon="shop"
                  class="mr-2 ml-md-0 ml-2"
                  scale="1.2"
                ></b-icon>
                {{ product.company_name }}
              </div>
            </div>
            <div
              class="border border-top-0 row shopping_car-item align-items-center py-2"
              v-for="item in product.items"
              :key="item.serial_no"
            >
              <div class="col-auto shopping_car-checkbox variant-platform">
                <b-form-checkbox
                  v-model="checkboxedList[key].item[item.productID]"
                  @change="checkProduct(key)"
                >
                </b-form-checkbox>
              </div>
              <div class="col pr-0 shopping_car-product-name">
                <div class="row align-items-center no-gutters ">
                  <div class="col-auto">
                    <div class="imgBox p-1 p-lg-2">
                      <div class="imgBox-inner">
                        <div class="imgBox-fit">
                          <img
                            :src="getAllImgUrl(item.image)"
                            class="card-img-top"
                            :alt="item.title"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <p class="shopping_car-product-text mb-0">
                      {{ item.serial_no }}
                    </p>
                    <h5 class="shopping_car-product-title">{{ item.title }}</h5>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-auto mb-2">
                <div
                  class="row align-items-center flex-md-row flex-row-reverse"
                >
                  <div class="col-md-auto shopping_car-product-price">
                    {{ toThousands(item.price) }}
                  </div>
                  <div class="col-6 col-md-auto shopping_car-product-count">
                    <b-input-group class="mb-0">
                      <template #prepend>
                        <b-button
                          squared
                          variant="outline-secondary"
                          type="button"
                          class="px-2"
                          @click="
                            incrementDecrementNumber(
                              '-',
                              'input' + item.productID,
                              item
                            )
                          "
                          :disabled="item.count == 1"
                          ><b-icon icon="dash"></b-icon
                        ></b-button>
                      </template>
                      <b-form-input
                        type="number"
                        v-model.number="item.count"
                        class="text-center"
                        style="max-width: 150px;border-color: #6c757d;"
                        :ref="'input' + item.productID"
                        @change="changeCount(item.productID, item.count)"
                      ></b-form-input>
                      <template #append>
                        <b-button
                          variant="outline-secondary"
                          squared
                          type="button"
                          class="px-2"
                          @click="
                            incrementDecrementNumber(
                              '+',
                              'input' + item.productID,
                              item
                            )
                          "
                          ><b-icon icon="plus"></b-icon
                        ></b-button>
                      </template>
                    </b-input-group>
                  </div>
                  <div class="col-6 col-md-auto shopping_car-product-subtotal">
                    {{ toThousands(item.price * item.count) }}
                  </div>
                  <div class="col-12 col-md-auto shopping_car-product-delete">
                    <b-button
                      variant="link"
                      class="px-2 text-platform_main"
                      @click="deleteProduct(item.productID)"
                    >
                      <b-icon icon="trash"></b-icon>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="border border-top-0 row shopping_car-footer py-2 text-right"
            >
              <div class="col">
                總金額
                <span class="text-manage_sub">{{
                  toThousands(companyTotalPrice(key))
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 pl-xl-5">
          <div class="border shopping_car-footer mb-3 py-2 row sticky-top">
            <div class="col-12">
              <div class="row align-items-center justify-content-between">
                <div class="col-auto shopping_car-checkbox variant-platform">
                  <b-form-checkbox
                    v-model="allSelected"
                    @change="checkCar"
                  ></b-form-checkbox>
                </div>
                <div class="col-auto mr-auto">
                  全選
                </div>
                <div class="col-12 col-md-auto text-right">
                  購買總金額
                  <span class="text-manage_sub">{{
                    toThousands(totalPrice())
                  }}</span>
                </div>
              </div>
              <hr />
            </div>
            <div class="col-12">
              <form ref="form" @submit.stop.prevent="submitOrder">
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      label="訂購人姓名"
                      label-for="userName"
                      invalid-feedback="請填寫姓名"
                      :state="state.name"
                      class="required"
                    >
                      <b-form-input
                        id="userName"
                        class="rounded-0"
                        v-model="form.name"
                        type="text"
                        required
                        placeholder="姓名"
                        :state="state.name"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      label="訂購人電話"
                      label-for="telephone"
                      invalid-feedback="請填寫電話"
                      :state="state.telephone"
                      class="required"
                    >
                      <b-form-input
                        id="telephone"
                        class="rounded-0"
                        v-model="form.telephone"
                        type="number"
                        required
                        placeholder="電話"
                        :state="state.telephone"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <TWCityTown
                  @childMethod="getTWCityTown"
                  :state="state.TW_city_town"
                  :group_class="'required'"
                  :town_id="form.town_id"
                  :address="form.address"
                ></TWCityTown>
                <b-button
                  squared
                  variant="platform_main"
                  type="submit"
                  class="float-right mb-3"
                  >確定送出</b-button
                >
              </form>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>
<style lang="scss" scoped>
.shopping_car {
  background-color: #f5f5f5;
  min-height: calc((var(--vh, 1vh) * 100) - 104px - 64px - 35px);
  &-header,
  &-group > div,
  &-footer {
    background-color: #fff;
  }
  &-checkbox {
    padding-right: 0;
  }
  &-company_name {
    font-weight: bold;
    font-size: 16px;
  }
  &-product-price,
  &-product-subtotal {
    width: 75px;
    text-align: right;
    padding-right: 5px;
    padding-left: 5px;
  }
  &-product-price {
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
  &-product-count {
    width: 200px;
    @include media-breakpoint-down(sm) {
      text-align: right;
      ::v-deep .input-group {
        display: inline-flex;
        margin-bottom: 10px;
      }
    }
  }
  &-product-delete {
    width: 65px;
    @include media-breakpoint-down(sm) {
      position: absolute;
      top: -56px;
      right: 0;
    }
  }
  &-product-name {
    .imgBox {
      width: 60px;
    }
    @include media-breakpoint-up(xl) {
      max-width: 209px;
    }
    @include media-breakpoint-down(sm) {
      padding-left: 0;
      padding-right: 40px;
    }
  }
  &-product-text {
    font-size: 14px;
    color: $platform_main;
    word-wrap: break-word;
  }
  &-product-title {
    font-size: 16px;
    word-wrap: break-word;
    @include media-breakpoint-down(md) {
      font-size: 14px;
      // max-width: 80px;
    }
    @include media-breakpoint-down(sm) {
      // max-width: 124px;
      margin-right: 50px;
    }
  }
  &-footer {
    top: 20px;
    span {
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>
<script>
import { ShoppingCar, Order, User } from "@/assets/api/platform.js";
import { Toast, Swal } from "@/plugins/sweetalert2.js";
import TWCityTown from "@/components/TWCityTown.vue";
export default {
  name: "ShoppingCar",
  props: ["token"],
  components: { TWCityTown },
  data() {
    return {
      allSelected: true,
      data: null,
      imageOnerror: "/img/image_onerror.jpg",
      checkboxedList: {},
      form: {
        items: [],
        name: "",
        address: "",
        telephone: "",
        town_id: ""
      },
      state: {
        name: null,
        telephone: null,
        TW_city_town: null
      }
    };
  },
  created() {
    User.get(this.token)
      .then(res => {
        if (res.status <= 201) {
          this.form.name = res.data.name;
          this.form.telephone = res.data.telephone;
          this.form.city_id = res.data.city_id;
          this.form.town_id = res.data.town_id;
          this.form.address = res.data.address;
        } else {
          Toast.fire({
            icon: "error",
            title: "個人資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    ShoppingCar.get(this.token)
      .then(res => {
        if (res.status <= 201) {
          this.data = res.data;
          this.createCheckboxedList();
          this.onerrorForImg();
        } else {
          Toast.fire({
            icon: "error",
            title: "購物車讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    getTWCityTown(data) {
      this.form.city_id = data.city_id;
      this.form.town_id = data.town_id;
      this.form.address = data.address;
    },
    randomcolor() {
      let cssHSL =
        "hsl(" +
        360 * Math.random() +
        "," +
        (20 + 60 * Math.random()) +
        "%," +
        (70 + 10 * Math.random()) +
        "%)";
      return cssHSL;
    },
    createCheckboxedList() {
      Object.keys(this.data).forEach(key => {
        this.$set(this.checkboxedList, key, {});
        this.$set(this.checkboxedList[key], "allCompany", true);
        this.$set(this.checkboxedList[key], "item", {});
        this.data[key].items.forEach(item => {
          this.$set(this.checkboxedList[key].item, item.productID, true);
        });
      });
    },
    incrementDecrementNumber(action, id, item) {
      this.$nextTick(function() {
        switch (action) {
          case "+":
            item.count++;
            this.$refs[id][0].$el.stepUp();
            this.changeCount(item.productID, item.count);
            break;
          case "-":
            item.count--;
            this.$refs[id][0].$el.stepDown();
            this.changeCount(item.productID, item.count);
            break;
        }
      });
    },
    getAllImgUrl(url) {
      return (process.env.VUE_APP_API_BASE_URL || "") + url;
    },
    checkCar() {
      this.$nextTick(function() {
        Object.keys(this.checkboxedList).forEach(val => {
          this.checkboxedList[val].allCompany = this.allSelected;
          Object.keys(this.checkboxedList[val].item).forEach(item => {
            this.checkboxedList[val].item[item] = this.allSelected;
          });
        });
      });
    },
    checkCompany(key) {
      this.$nextTick(function() {
        Object.keys(this.checkboxedList[key].item).forEach(item => {
          this.checkboxedList[key].item[item] = this.checkboxedList[
            key
          ].allCompany;
        });
        this.checkAll();
      });
    },
    checkProduct(key) {
      this.$nextTick(function() {
        let qty = 0;
        Object.keys(this.checkboxedList[key].item).forEach(item => {
          if (this.checkboxedList[key].item[item]) {
            qty++;
          }
        });
        if (qty == Object.keys(this.checkboxedList[key].item).length) {
          this.checkboxedList[key].allCompany = true;
        } else {
          this.checkboxedList[key].allCompany = false;
        }
        this.checkAll();
      });
    },
    checkAll() {
      this.$nextTick(function() {
        let allQty = 0;
        Object.keys(this.checkboxedList).forEach(key => {
          if (this.checkboxedList[key].allCompany) {
            allQty++;
          }
        });
        if (allQty == Object.keys(this.checkboxedList).length) {
          this.allSelected = true;
        } else {
          this.allSelected = false;
        }
      });
    },
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    onerrorForImg() {
      this.$nextTick(() => {
        var imgList = document.querySelectorAll("img");
        Array.prototype.forEach.call(imgList, item => {
          item.onerror = () => {
            item.src = this.imageOnerror;
          };
        });
      });
    },
    companyTotalPrice(id) {
      let totalPrice = 0;
      this.data[id].items.forEach(item => {
        if (this.checkboxedList[id].item[item.productID]) {
          totalPrice = totalPrice + item.price * item.count;
        }
      });
      return totalPrice;
    },
    totalPrice() {
      let totalPrice = 0;
      Object.keys(this.data).forEach(val => {
        this.data[val].items.forEach(item => {
          if (this.checkboxedList[val].item[item.productID]) {
            totalPrice = totalPrice + item.price * item.count;
          }
        });
      });
      return totalPrice;
    },
    changeCount(id, count) {
      ShoppingCar.update(id, { count: count }, this.token)
        .then(res => {
          if (res.status > 201) {
            Toast.fire({
              icon: "error",
              title: "更改數量失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteProduct(id) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除商品嗎？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          ShoppingCar.delete(id, this.token)
            .then(res => {
              if (res.data.status == "success") {
                ShoppingCar.get(this.token)
                  .then(res => {
                    if (res.status <= 201) {
                      this.data = res.data;
                      this.createCheckboxedList();
                      this.onerrorForImg();
                      const shopping_car = res.data;
                      let newQty = 0;
                      Object.keys(shopping_car).forEach(key => {
                        newQty = newQty + shopping_car[key].items.length;
                      });
                      this.$emit("shoppingCarQty", newQty);
                    } else {
                      Toast.fire({
                        icon: "error",
                        title: "購物車讀取失敗",
                        text: res.data.error
                      });
                    }
                  })
                  .catch(error => {
                    console.error(error);
                  });
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.form.name ? (this.state.name = null) : (this.state.name = false);
      this.form.town_id && this.form.address && this.form.city_id
        ? (this.state.TW_city_town = null)
        : (this.state.TW_city_town = false);
      this.form.telephone
        ? (this.state.telephone = null)
        : (this.state.telephone = false);
    },
    submitOrder() {
      if (!this.checkFormValidity()) {
        return;
      }
      for (const value of Object.keys(this.state)) {
        if (this.state[value] === false) {
          return;
        }
      }

      Object.keys(this.checkboxedList).forEach(val => {
        Object.keys(this.checkboxedList[val].item).forEach(item => {
          if (this.checkboxedList[val].item[item]) {
            this.data[val].items.forEach(data => {
              if (data.productID == item) {
                this.form.items.push({
                  productID: item,
                  count: data.count
                });
              }
            });
          }
        });
      });
      Order.create(this.form, this.token)
        .then(res => {
          if (res.status <= 201) {
            let oder = "";
            res.data.orderIDs.forEach((val, index) => {
              if (index) oder += "&";
              oder += val;
            });
            this.$router.push(`/callBack/${oder}`);
          } else {
            Toast.fire({
              icon: "error",
              title: "建立訂單失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  mounted() {}
};
</script>
